import { ApolloClient, from } from '@apollo/client';
import { authLink } from './auth-link';
import { httpLink } from './http-link';
import { errorLink } from './error-link';
import { getCache as getRelayCache } from './relay-cache';
import { getCache as getSimpleCache } from './simple-cache';

const defaultOptions = {
    query: {
        notifyOnNetworkStatusChange: true
    },
    watchQuery: {
        notifyOnNetworkStatusChange: true
    }
};

const getNewApolloClient = (isRelayCache = false) => new ApolloClient({
    cache: isRelayCache ? getRelayCache() : getSimpleCache(),
    link: from([authLink, errorLink, httpLink]),
    defaultOptions
})

const getNewRelayClient = () => getNewApolloClient(true);

const client = getNewRelayClient();

// A secondary client that will be used in the Maintenance components
// and asset search component with normal numbered pagination.
// This client will not use the relay cache.
// Both relay cache and normal cache are not possible for the same field in a client.
const simpleClient = getNewApolloClient();

export {
    simpleClient
}

export default client;